// Components
import { FeaturedItem, Shelf } from '@tracklib/kit'

const firstTwo = (i, index) => index < 3

type FeaturedItemsBlockProps = {
  value: {
    items: Array<typeof FeaturedItem>
  }
}

const FeaturedItemsBlock = ({ value: { items } }: FeaturedItemsBlockProps): JSX.Element => (
  <Shelf>
    {items.filter(firstTwo).map(item => {
      const { title, body, image, button_url, button_text } = item
      return (
        <Shelf.Item key={item.title}>
          <FeaturedItem title={title} body={body} image={image} buttonUrl={button_url} buttonText={button_text} />
        </Shelf.Item>
      )
    })}
  </Shelf>
)

export default FeaturedItemsBlock
